export default __webpack_public_path__ + "static/media/facebookLetter.acab7b62.svg";